/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './invalid.setup.user.tpl.html';

angular
  .module('shared.invalidConfig', ['ui.router'])
  // This defines the invalid config view that is shared across all subviews.
  .config([
    '$stateProvider',
    'VIEW_STATES',
    function ($stateProvider, VIEW_STATES) {
      $stateProvider.state(VIEW_STATES.INVALID_CONFIG, {
        url: '/invalidConfig',
        views: {
          content: {
            templateUrl: 'shared/invalidConfig/invalid.setup.user.tpl.html'
          }
        }
      });
    }
  ]);
